import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils/cn";
const laptopVariants = cva("mx-auto flex flex-col items-center shrink-0 [--base:301px] [--max-width:calc(var(--base)*1)] [--screen-height:calc(var(--base)*0.46125)] [--frame-height:calc(var(--base)*0.5)] [--bottom-bar-height:calc(var(--base)*0.045)] [--bottom-bar-width:calc(var(--base)*1.160714)] [--notch-width:calc(var(--base)*0.185714)] [--notch-height:calc(var(--base)*0.016429)] [--outer-radius:calc(var(--base)*0.035714)] [--inner-radius:calc(var(--base)*0.021429)]", {
  variants: {
    size: {
      sm: "",
      md: "lg:[--base:512px]",
      lg: "lg:[--base:800px]"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
export interface LaptopMockupProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof laptopVariants> {
  children?: React.ReactNode;
}

/**
 * A reusable Laptop Mockup component for displaying images, videos, or other content.
 * Follows the laptop mockup design with dynamic content slot and keyboard base.
 */
export const LaptopMockup: React.FC<LaptopMockupProps> = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      children,
      size,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = size;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    size = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== size) {
    t1 = cn(laptopVariants({
      size
    }), className);
    $[5] = className;
    $[6] = size;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      borderTopLeftRadius: "var(--outer-radius)",
      borderTopRightRadius: "var(--outer-radius)"
    };
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children) {
    t3 = <div className="relative h-(--frame-height) w-full max-w-(--max-width) border-8 border-b-0 border-black bg-black shadow-xl" style={t2}><div className="h-(--screen-height) w-full overflow-hidden bg-white dark:bg-black rounded-t-(--inner-radius)"><div className="relative h-full w-full aspect-video">{children}</div></div></div>;
    $[9] = children;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative h-(--bottom-bar-height) w-[110%] max-w-(--bottom-bar-width) rounded-b-xl rounded-t-xs bg-[#d6d6d6]"><div className="absolute left-1/2 top-0 h-(--notch-height) w-(--notch-width) -translate-x-1/2 rounded-b-xl bg-black" /></div>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t3) {
    t5 = <div className={t1} {...props}>{t3}{t4}</div>;
    $[12] = props;
    $[13] = t1;
    $[14] = t3;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};